/**
 * Skill-tree glyph contract.
 * ---------------------------------------------------------------
 * Every hand-drawn skill-tree mark takes the same props as a Lucide icon
 * (`className`, `strokeWidth`) so it can drop into existing call sites.
 * Colour always comes from `currentColor` — never a hardcoded hex — so the
 * marks inherit the stage accent or a semantic token from their container.
 */
import type React from 'react';

export interface SkillGlyphProps {
  className?: string;
  strokeWidth?: number;
  style?: React.CSSProperties;
  'aria-hidden'?: boolean | 'true' | 'false';
}

export type SkillGlyph = React.FC<SkillGlyphProps>;

/** Shared base props for the 24-box drawings. */
export const glyphBase = {
  viewBox: '0 0 24 24',
  fill: 'none' as const,
  stroke: 'currentColor',
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};
